// extracted by mini-css-extract-plugin
export var copyIcon = "_z0-2";
export var discountCard = "_z0-0";
export var discountCode = "_z0-3";
export var discountContent = "_z0-1";
export var loadingCard = "_z0-4";